import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import { CENTER } from '../../../base/helpers/style'
import images from '../../../configs/images'
import { IHistoryItem } from '../../../interfaces/history'
import services from '../../../services'
import db from '../../../services/db'
import { HistoryImage } from './history-image'

export const HistoryItem = (item: IHistoryItem) => {

    const base = Div()
    const { prompt, urls, isFavorite } = item

    const promptDiv = Div(prompt)
    const urlsDiv = Div()
    const imagesList = urls.map(HistoryImage)
    urlsDiv.append(...imagesList)
    const heart = Img(images.ICONS.HEART, { width: 32 })

    heart.el.onclick = () => {
        item.isFavorite = (isFavorite === 0 || isFavorite === undefined) ? 1 : 0
        services.history.update(item)
        heart.style({ opacity: item.isFavorite ? '1' : '.3' })
    }
    base.append(promptDiv, urlsDiv, heart)

    promptDiv.cssClass({
        width: '25%',
        '@media (max-width: 768px)': {
            width: '100%',
        }
    })
    heart.cssClass({
        opacity: isFavorite ? '1' : '.3',
        cursor: 'pointer'
    })
    base.cssClass({
        ...CENTER,
        flexDirection: 'row',
        marginBottom: '5px',
        justifyContent: 'space-between',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
            justifyContent: 'flex-start',
            marginBottom: '25px',

        }
    })

    return base
}